<ion-grid class="bg-white rounded-lg font-sans" style="padding: 20px">
	<ion-row>
		<ion-col size="12">
			<div class="text-2xl text-center pb-20 font-bold">Forgot Password?</div>
			<form
				[formGroup]="forgotPasswordForm"
				(ngSubmit)="onSubmit(forgotPasswordForm)"
			>
				<ion-item class="signupFormItem" lines="full">
					<ion-label position="floating text-lg">Enter your email id</ion-label>
					<ion-input formControlName="email" type="text"></ion-input>
				</ion-item>

				<ng-container
					*ngFor="let validation of forgotPasswordErrorMessages.email"
				>
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							forgotPasswordForm.get('email')?.hasError(validation.type) &&
							(forgotPasswordForm.get('email')?.dirty ||
								forgotPasswordForm.get('email')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>

				<ion-button
					class="font-sans text-lg h-50 yellowButton"
					type="submit"
					expand="block"
					>Reset the password
					<ion-spinner *ngIf="isLoading" class="text-black"></ion-spinner>
				</ion-button>
			</form>
		</ion-col>
	</ion-row>
	<!-- <ion-row class="mt-20">
		<ion-col class="">
			<div class="text-lg">
				Don't have an account?
				<a
					(click)="authService.redirectAuth('sign-up')"
					class="text-blue-600 cursor-pointer no-underline"
					>Sign up</a
				>
			</div>
		</ion-col>
	</ion-row> -->
</ion-grid>
